import { Injectable } from '@angular/core';
import { StoreData } from '@shared/module/common/model/store-data';
import { Observable } from 'rxjs/Observable';
import { LemsarApiClient } from '@lemsar/api/client';
import { UI } from '@shared/models/ui';
import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { Collection } from '@lemsar/common/domains/interface/collection';
import { Instructor } from '../model/instructor';
import { pipe } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class InstructorService {
    private _ui: StoreData<UI>;

    public constructor(private api: LemsarApiClient) {
        this._ui = new StoreData<UI>(new UI());
    }

    public get ui$(): Observable<UI> {
        return this._ui.stream$;
    }

    public get ui(): UI {
        return this._ui.value;
    }

    public fetchInstitutionInstructors(id: string, params?: any): Observable<Collection<Instructor>> {
        const queryParams = !params
            ? { page: 1, limit: 20 }
            : { page: params.page || 1, limit: params.limit || 20, group: params.group || [] };

        this._ui.value.loading = true;

        return this.api.get<any>('institutions/' + id + '/instructors', queryParams).pipe(
            ResponseTransformer.toCollection(Instructor),
            this.finalize(),
        );
    }

    public checkProfileByNIK(nik: string): Observable<any> {
        return this.api.get<any>('check-profiles', { nik }).pipe(
            ResponseTransformer.toData(),
        );
    }

    public createInstitutionInstructor(institutionId: string, nik: string): Observable<any> {
        this._ui.value.loading = true;

        return this.api.post<any>('institutions/' + institutionId + '/instructors', { nik }).pipe(
            ResponseTransformer.toData(),
            this.finalize(),
        );
    }

    public deleteInstructor(institutionId: string, id: string): Observable<any> {
        return this.api.delete<any>('institutions/' + institutionId + '/instructors/' + id).pipe(
            ResponseTransformer.toData(),
        );
    }

    public finalize(): any {
        return pipe(
            finalize(() => this._ui.value.loading = false),
        );
    }

}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/services/instructor.service.ts